import styled from "styled-components";

export const InstitutionSection = styled.div`
    width: 100%;
    max-width: 400px;

    @media only screen and (max-width: 600px) {
        width: 100%;
        max-width: 100%;
    }
`;

export const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const TableWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    
    @media only screen and (min-width: 601px) {
        max-height: 200px;
        padding: 14px;
        border-radius: 1rem;
        background-color: var(--theme-color-tertiary);
        border: 1px solid var(--table-border-color);
    }

    @media only screen and (max-width: 600px) {
        max-height: 200px;
    }
`;

export const LabelWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 5px;
`;

export const Label = styled.label`
    display: flex;
    margin-bottom: 5px;
`;

export const LabelAction = styled.div`
    display: flex;
    align-items: center;
    gap: 3px;
    font-size: 12px;
    color: var(--theme-color-primary);
    text-decoration: underline;
    cursor: pointer;
    margin-bottom: 5px;

    svg {
        width: 14px;
        height: auto;
    }
`;

export const ActionsContainer = styled.div`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: end;
    gap: 10px;
`;

export const FormError = styled.p`
    color: var(--color-error);
    font-size: 11px;
    padding-top: 2px;
`;